import axios from "axios";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};
const axiosInstance = axios.create({
  // baseURL: "http://localhost:8000/api",
  baseURL: "https://digitallibrary-backend.fipi.org.in/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// vjfbjvbdj
// Request Interceptor

// axiosInstance.interceptors.request.use(
//   (config) => {
//     if (!config.headers["Content-Type"])
//     {
//       config.headers["Content-Type"] = "application/json";
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );


axiosInstance.interceptors.request.use(
  (config) => {
    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }


 
    // ✅ Yeh line add karo — token har request mein jayega
    const token = localStorage.getItem("access") || sessionStorage.getItem("access");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);


// Response Interceptor

// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const status = error?.response?.status;

//     if (status === 401) {
//       localStorage.removeItem("token");
//       window.location.href = "/";
//     }

//     return Promise.reject(error);
//   }
// );


axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error?.response?.status;

    if (status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return axiosInstance(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshToken = sessionStorage.getItem("refresh") || localStorage.getItem("refresh");
        if (refreshToken) {
          const res = await axios.post(`${axiosInstance.defaults.baseURL}/auth/refresh/`, {
            refresh: refreshToken,
          });

          if (res.data.access) {
            sessionStorage.setItem("access", res.data.access);
            axiosInstance.defaults.headers.common.Authorization = `Bearer ${res.data.access}`;
            originalRequest.headers.Authorization = `Bearer ${res.data.access}`;

            processQueue(null, res.data.access);
            return axiosInstance(originalRequest);
          }
        }
      } catch (refreshError) {
        processQueue(refreshError, null);
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = "/";
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    if (status === 401) {


      console.log("Unauthorized request");

      localStorage.removeItem("access");
      localStorage.removeItem("refresh");
      localStorage.removeItem("authUser");

      sessionStorage.removeItem("access");
      sessionStorage.removeItem("refresh");
      sessionStorage.removeItem("user_info");

      // window.location.href = "/";

    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
